import Vue from 'vue';
import _ from 'lodash';
import { UPDATE_BASIC_FILTER } from '@/main/store/listEditTypes';

import { OpenerOptions } from '../store/@types/external.d';

export const OpenerMixin = Vue.extend({
	computed: {
		externalOpener(): OpenerOptions | null {
			return this.$store.state.external.opener || null;
		},
		isExternal(): boolean {
			return !!this.externalOpener?.opener;
		},
	},
	methods: {
		setFiltersFromExternal(storeUri: string) {
			if (this.externalOpener && this.externalOpener.extraParams && Object.keys(this.externalOpener.extraParams).length > 0) {
				this.$store.commit(`${storeUri}/${UPDATE_BASIC_FILTER}`, { Filter: this.externalOpener.extraParams });
			}
		},
		openerSelect(data: Record<string, string>) {
			const targetWindow = window.parent;

			targetWindow.postMessage(
				JSON.stringify({ raw: data, prop: this.externalOpener!.prop }),
				this.externalOpener!.host!,
			);
		},
	},
});
